import { mediaData } from '@/mocks/homepage';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-play-circle-line text-sm"></i>
            </div>
            热门视频
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-3">
            网友正在看的热门内容
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            91视频网站实时热门内容精选，高清在线观看不缓冲
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaData.map((item) => (
            <div
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-accent-200 transition-all cursor-pointer"
            >
              <div className="aspect-video overflow-hidden bg-background-200 relative">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute bottom-2 right-2 bg-black/70 backdrop-blur-sm px-2 py-0.5 rounded-md text-xs text-background-100 font-mono whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-12 h-12 rounded-full bg-accent-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-bold text-foreground-900 font-heading mb-2 line-clamp-2 group-hover:text-accent-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="whitespace-nowrap">{item.views}次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}